import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['create', 'date', 'amount', 'category_name', 'tags_text_list', 'comment'];

  static fieldsList = ['amount', 'category_name', 'tags_text_list', 'comment'];

  connect() {
    this.initButton();
  }

  addRow() {
    this.constructor.fieldsList.forEach((field) => this.addField(field));
    this.addRemovalButton(this.amountTargets.length - 1);
  }

  addField(name) {
    const target = this[`${name}Target`];
    const count = this[`${name}Targets`].length;
    const field = target.cloneNode();

    field.id = `activity_details_${name}_${count}`;
    field.name = `activity[details][${count - 1}][${name}]`;
    field.tabIndex += count + 1;
    field.value = '';

    target.parentNode.append(field);

    if (name === 'amount') {
      field.focus();
    }
  }

  addRemovalButton(number) {
    const button = document.createElement('button');
    button.type = 'button';
    button.dataset.action = 'activity-detail#removeRow';
    button.dataset.rowNumber = number;
    button.classList.add('button', 'is-block', 'is-danger', 'is-light', 'is-outlined');
    button.innerHTML = '-';
    this.dateTarget.parentNode.append(button);
  }

  removeRow(event) {
    // event.stopImmediatePropagation();

    const number = event.target.dataset.rowNumber;

    let allEmpty = this.constructor.fieldsList.every(
      (field) => document.getElementById(`activity_details_${field}_${number}`).value === ''
    );

    if (!allEmpty && !confirm('Are you sure?')) {
      return;
    }

    this.constructor.fieldsList.forEach((field) => {
      const node = document.getElementById(`activity_details_${field}_${number}`);
      node.parentElement.removeChild(node);
    });

    event.target.parentElement.removeChild(event.target);
  }

  initButton() {
    const button = document.createElement('button');
    button.type = 'button';
    button.dataset.action = 'activity-detail#addRow';
    button.classList.add('button', 'is-success', 'is-light', 'is-outlined');
    button.innerHTML = '+';
    this.createTarget.after(button);
  }
}
